module.exports = __webpack_public_path__ + "static/img/grey2.521ba1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grey2.png
// module id = qnr0
// module chunks = 1